import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=03f71878&"
import script from "./Backup.vue?vue&type=script&lang=js&"
export * from "./Backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports